module.exports = __webpack_public_path__ + "img/blueSapphireRings@2x.784821c.png";